import React, { useEffect } from "react"
import {
  REV_BERRI_ROUTE,
  REV_BERRI_TOTAL_KM,
  formatKm
} from "./revBerriRoute"
import { trackEvent } from "./analytics"
import "./VeloIntro.css"

function setMetaAttribute(selector, attr, value) {
  let tag = document.head.querySelector(selector)

  if (!tag) {
    tag = document.createElement("meta")

    if (selector.includes("property=")) {
      tag.setAttribute(
        "property",
        selector.match(/property="([^"]+)"/)?.[1] || ""
      )
    } else {
      tag.setAttribute(
        "name",
        selector.match(/name="([^"]+)"/)?.[1] || ""
      )
    }

    document.head.appendChild(tag)
  }

  tag.setAttribute(attr, value)
}

function applyVeloMetaTags() {
  if (typeof document === "undefined") return

  const origin =
    typeof window !== "undefined"
      ? window.location.origin
      : "https://www.ahuncycle.com"

  const pageUrl = `${origin}${REV_BERRI_ROUTE.publicPath}`
  const imageUrl = `${origin}${REV_BERRI_ROUTE.ogImage}`

  document.title = REV_BERRI_ROUTE.ogTitle

  setMetaAttribute(
    'meta[name="description"]',
    "content",
    REV_BERRI_ROUTE.ogDescription
  )

  setMetaAttribute(
    'meta[property="og:title"]',
    "content",
    REV_BERRI_ROUTE.ogTitle
  )

  setMetaAttribute(
    'meta[property="og:description"]',
    "content",
    REV_BERRI_ROUTE.ogDescription
  )

  setMetaAttribute(
    'meta[property="og:image"]',
    "content",
    imageUrl
  )

  setMetaAttribute(
    'meta[property="og:url"]',
    "content",
    pageUrl
  )

  setMetaAttribute(
    'meta[property="og:type"]',
    "content",
    "website"
  )

  setMetaAttribute(
    'meta[property="og:image:width"]',
    "content",
    "1200"
  )

  setMetaAttribute(
    'meta[property="og:image:height"]',
    "content",
    "630"
  )

  setMetaAttribute(
    'meta[property="og:image:type"]',
    "content",
    "image/jpeg"
  )
}

export default function VeloIntro({
  onStart,
  isGameReady = false
}) {
  useEffect(() => {
    applyVeloMetaTags()

    trackEvent("velo_intro_view", {
      game_name: REV_BERRI_ROUTE.name,
      route_name: REV_BERRI_ROUTE.routeName
    })
  }, [])

  return (
    <main className="velo-intro">
      <img
        className="velo-intro__background"
        src={REV_BERRI_ROUTE.ogImage}
        alt=""
        aria-hidden="true"
      />

      <div className="velo-intro__shade" />

      <section className="velo-intro__card">
        <p className="velo-intro__tagline">
          De Gouin au parc René-Lévesque, traverse Montréal à vélo.
        </p>

        <div className="velo-intro__facts">
          <div className="velo-intro__fact velo-intro__fact--route">
            <span>Parcours</span>
            <strong>{REV_BERRI_ROUTE.displayRoute}</strong>
          </div>

          <div className="velo-intro__fact velo-intro__fact--distance">
            <span>Distance</span>
            <strong>{formatKm(REV_BERRI_TOTAL_KM)}</strong>
          </div>
        </div>

        <p className="velo-intro__challenge">
          Obstacles, circulation, virages et réflexes : jusqu’où peux-tu aller?
        </p>

        <button
          className="velo-intro__button"
          type="button"
          onClick={onStart}
        >
          Démarrer le parcours
        </button>

        <p
          className={
            isGameReady
              ? "velo-intro__status velo-intro__status--ready"
              : "velo-intro__status"
          }
        >
          {isGameReady ? "Parcours prêt." : "Préparation du parcours…"}
        </p>
      </section>
    </main>
  )
}